import maplibregl from 'maplibre-gl';
import { getTileUrl } from '../../../../config';
import { ForecastWidgetConfig, WidgetRenderContext, WidgetRenderer } from '../types';

export class MiniMapWidget implements WidgetRenderer {
  public renderHtml(widget: ForecastWidgetConfig, _ctx: WidgetRenderContext): string {
    const title = widget.title || 'Forecast Map Snippet';
    const height = widget.options?.height || 200;
    const mapId = `poi-mini-map-${widget.id}`;

    return `
      <div class="metric-card" style="background: rgba(255,255,255,0.03); border: 1px solid var(--border-light); border-radius: 8px; padding: 12px; display: flex; flex-direction: column;">
        <h3 style="margin: 0 0 10px 0; color: #f8fafc; font-size: 0.95rem;">🗺️ ${title}</h3>
        <div id="${mapId}" style="height: ${height}px; width: 100%; border-radius: 6px; background: #0f172a; position: relative;"></div>
      </div>
    `;
  }

  public init(widget: ForecastWidgetConfig, ctx: WidgetRenderContext): void {
    const mapId = `poi-mini-map-${widget.id}`;
    const container = document.getElementById(mapId);
    if (!container || !ctx.manifest) return;

    const lat = ctx.lat;
    const lon = ctx.lon;
    const product = widget.options?.product || 'aurora';
    const zoom = widget.options?.zoom || 4;

    const mapInstance = new maplibregl.Map({
      container: mapId,
      style: {
        version: 8,
        sources: {
          osm: {
            type: 'raster',
            tiles: ['https://a.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png'],
            tileSize: 256
          }
        },
        layers: [
          {
            id: 'osm-layer',
            type: 'raster',
            source: 'osm',
            minzoom: 0,
            maxzoom: 18
          }
        ]
      },
      center: [lon, lat],
      zoom,
      interactive: false,
      attributionControl: false
    });

    if (widget.options?.show_poi_pin !== false) {
      new maplibregl.Marker({ color: '#facc15' })
        .setLngLat([lon, lat])
        .addTo(mapInstance);
    }

    ctx.maps.push(mapInstance);

    // If aurora or raster product
    if (product === 'aurora') {
      const targetDate = ctx.data.darkskiesTrends?.[0]?.auroraDateStr || ctx.dateStr;
      const auroraUrl = getTileUrl(ctx.manifest, 'aurora', '', targetDate, '');
      mapInstance.on('load', () => {
        if (!mapInstance.getStyle()) return;
        mapInstance.addSource('mini-raster-source', {
          type: 'raster',
          url: auroraUrl.replace(/\/{z}\/{x}\/{y}.*$/, ''),
          tileSize: 256
        });
        mapInstance.addLayer({
          id: 'mini-raster-layer',
          type: 'raster',
          source: 'mini-raster-source',
          paint: { 'raster-opacity': 0.7 }
        });
      });
    }
  }
}
